var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchx1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 15.19997,
    height: 14.56,
    viewBox: "0 0 15.19997 14.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath368"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path368"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath370"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path370"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath372"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path372"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath374"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path374"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath376"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path376"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath378"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path378"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath380"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path380"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath382"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path382"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath384"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path384"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath386"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path386"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath388"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path388"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath390"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path390"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath392"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path392"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath394"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath396"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path396"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath398"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path398"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "rotate(90,4093,1501.5)",
    id: "path400"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-oc2",
    transform: "translate(-152.5867,-355.78667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path367",
    d: "m 2614,5592 v 4 l -1,-8 z m 0,4 -1,-8 v 13 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path369",
    d: "m 2613,5588 v 13 l -1,-17 z m 0,13 -1,-17 v 21 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath370)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path371",
    d: "m 2612,5584 v 21 l -2,-25 z m 0,21 -2,-25 v 28 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path373",
    d: "m 2610,5580 v 28 l -3,-31 z m 0,28 -3,-31 v 35 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path375",
    d: "m 2607,5577 v 35 l -4,-38 z m 0,35 -4,-38 v 40 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path377",
    d: "m 2603,5574 v 40 l -4,-42 z m 0,40 -4,-42 v 44 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path379",
    d: "m 2599,5572 v 44 l -4,-45 z m 0,44 -4,-45 v 46 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath380)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path381",
    d: "m 2595,5571 v 46 l -4,-47 z m 0,46 -4,-47 v 48 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path383",
    d: "m 2591,5570 v 48 l -5,-47 z m 0,48 -5,-47 v 46 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path385",
    d: "m 2586,5571 v 46 l -4,-45 z m 0,46 -4,-45 v 44 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path387",
    d: "m 2582,5572 v 44 l -4,-42 z m 0,44 -4,-42 v 40 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path389",
    d: "m 2578,5574 v 40 l -3,-37 z m 0,40 -3,-37 v 35 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath390)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path391",
    d: "m 2575,5577 v 35 l -3,-32 z m 0,35 -3,-32 v 28 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path393",
    d: "m 2572,5580 v 28 l -3,-24 z m 0,28 -3,-24 v 21 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path395",
    d: "m 2569,5584 v 21 l -1,-17 z m 0,21 -1,-17 v 13 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path397",
    d: "m 2568,5588 v 13 l -1,-9 z m 0,13 -1,-9 v 4 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path399",
    d: "M 23.5,0 C 23.5,12.97869 12.97869,23.5 0,23.5 -12.97869,23.5 -23.5,12.97869 -23.5,0 c 0,-12.97869 10.52131,-23.5 23.5,-23.5 12.97869,0 23.5,10.52131 23.5,23.5",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.16,0,0,-0.16,163.54667,360.02667)",
    clipPath: "url(#clipPath400)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path401",
    d: "m 2569,5604 -39,18 v 38",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchx1);
export default __webpack_public_path__ + "static/media/switchx1.1adcbb381a510bcf2c97b726634dde7b.svg";
export { ForwardRef as ReactComponent };